import axios from "axios";
import { apiConfig } from "@/config/apiConfig"; // Import API config
import Swal from "sweetalert2";
import { swal } from "sweetalert2/dist/sweetalert2";

// Utility function to get the access token
const getAccessToken = () => localStorage.getItem("accessToken");

// Login function
export const login = async (phone, password) => {
  try {
    const secretKey = apiConfig.secretKey;
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.loginUrl}`,
      {
        phone,
        password,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "SECRET-KEY": `${secretKey}`,
          SOURCE: "web",
        },
      }
    );
    // console.log("Login response:", response);
    // Save the token and auth data in localStorage
    localStorage.setItem("accessToken", response.data.access); // Save token persistently
    localStorage.setItem("authData", JSON.stringify(response.data)); // Save full auth data if needed
    localStorage.setItem("refreshToken", JSON.stringify(response.data.refresh)); // Save refresh token
    return response.data.access;
  } catch (error) {
    console.error(
      "Login failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const logout = async (phone, password) => {
  try {
    const secretKey = apiConfig.secretKey;
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.logoutUrl}`,
      {
        phone,
        password,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "SECRET-KEY": `${secretKey}`,
          SOURCE: "web",
        },
      }
    );
    localStorage.removeItem("accessToken");
    localStorage.removeItem("authData");
    localStorage.removeItem("refreshToken");
    sessionStorage.clear();
  } catch (error) {
    console.error(
      "Logout failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const verifyOtp = async (form) => {
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.verifyOtpUrl}`,
      form
    );
    Swal.fire({
      icon: "success",
      title: "Registration Successful",
      text: "You have successfully registered.",
      confirmButtonColor: "#4CAF50",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    // swal.showLoading();
    // Save the token and auth data in localStorage

    return response.data;
  } catch (error) {
    console.error(
      "verifyOtp failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const ResendOtp = async (form) => {
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.sendOtpUrl}`,
      form
    );

    return response.data;
  } catch (error) {
    console.error(
      "ResendOtp failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
export const register = async (form) => {
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.registerUrl}`,
      form
    );

    return response.data;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Registration Failed",
      text: error.response.data.message,
      confirmButtonColor: "#4CAF50",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
    throw error;
  }
};

export const changePassword = async (form) => {
  try {
    const accessToken = getAccessToken();
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.changePasswordUrl}`,
      form,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Registration failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const changeProfileData = async () => {
  try {
    const accessToken = getAccessToken();
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.profileUrl}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Registration failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const postProfileData = async (form) => {
  try {
    const accessToken = getAccessToken();
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.profileUrl}`,
      form,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // console.log("Updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Update failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const patchProfileImage = async (imageFile) => {
  try {
    const accessToken = getAccessToken();

    const formData = new FormData();
    formData.append("image", imageFile);

    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.profileUrl}`,
      formData,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // console.log("Image updated successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Image upload failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const sendEmail = async (form) => {
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.sendEmailUrl}`,
      form
    );

    return response.data;
  } catch (error) {
    console.error(
      "sendEmail failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Get school details
export const schoolDetail = async () => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }

    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.schooDetailsUrl}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch school details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Post school details
export const updateSchoolDetail = async (formData) => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }

    // Make POST request with FormData
    const response = await axios.put(
      `${apiConfig.baseUrl}${apiConfig.schooDetailsUrl}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Registration failed:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Get class details
export const classNames = async () => {
  try {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }

    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.classinfo}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch class details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Get students
export const studentLists = async (id) => {
  try {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }

    if (!id) {
      throw new Error("CLASS-ID is missing.");
    }

    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "CLASS-ID": id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchClassVerificationStatus  = async (id, form) => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    if (!id) {
      throw new Error("CLASS-ID is missing.");
    }

    // console.log("Before sending PATCH request");
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.classVerified}`,
      form,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "CLASS-ID": id,
        },
      }
    );
    // console.log("Student verified successfully:", response);
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const readNotification  = async (id) => {

  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    if (!id) {
      throw new Error("NOTIFICATION-ID is missing.");
    }
    // console.log("Before sending PATCH request");
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.notificationDetail}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "NOTIFICATION-ID": id,
        },
      }
    );
    // console.log("Student verified successfully:", response);
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const readAllNotification  = async () => {
  try {
    const accessToken = getAccessToken();
    // console.log("Access Token:", accessToken);
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }

    // console.log("Before sending PATCH request");
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.notificationDetail}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
     
        },
      }
    );
    // console.log("readAllNotification successfully:", response);
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Post students
export const addStudentView = async (formData, classID) => {
  console.log('fomr', formData)
  console.log("formData", formData)
  for (let pair of formData.entries()) {
  console.log(`Hamro data -> ${pair[0]}:`, pair[1]);
}
  const accessToken = getAccessToken();
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
           "CLASS-ID": classID,
        },
      }
    );
    // console.log("Student added succussfully:", response.data);
    return response;
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
};

// Get student details
export const studentDetail = async (studentId, classId) => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    if (!studentId) {
      throw new Error("Student ID is missing.");
    }
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "CLASS-ID": classId,
          "STUDENT-ID": studentId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Get student details
export const migrateStudent = async (form, studentId, classIdFromRoute) => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
      form,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "CLASS-ID": classIdFromRoute,
          "STUDENT-ID": studentId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const migratedStudent = async () => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.migratedstudentsDetail}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchNotificationsWithCount = async () => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }

    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    };

    const [listResponse, countResponse] = await Promise.all([
      axios.get(`${apiConfig.baseUrl}${apiConfig.notificationDetail}`, {
        headers,
        params: { type: "list" },
      }),
      axios.get(`${apiConfig.baseUrl}${apiConfig.notificationDetail}`, {
        headers,
        params: { type: "count" },
      }),
    ]);

    return {
      list: listResponse.data,
      count: countResponse.data,
    };
  } catch (error) {
    console.error(
      "Failed to fetch notifications or count:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Users
export const addUserView = async (formData) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.veryfiedUser}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("User added succussfully:", response.data);
    return response;
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
};

export const getUser = async () => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.veryfiedUser}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const postUser = async (
  first_name,
  last_name,
  contact,
  email,
  password,
  class_info
) => {
  // try {
  const accessToken = getAccessToken();
  if (!accessToken) {
    throw new Error("No access token found. Please log in first.");
  }

  const formData = new FormData();
  formData.append("first_name", first_name);
  formData.append("last_name", last_name);
  formData.append("contact", contact);
  formData.append("email", email);
  formData.append("password", password);
  formData.append("class_info", class_info);

  // Make POST request with FormData
  const response = await axios.post(
    `${apiConfig.baseUrl}${apiConfig.veryfiedUser}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
  //   } catch (error) {
  //     console.error(
  //       "Registration failed:",
  //       error.response ? error.response.data : error.message
  //     );
  //     throw error;
  //   }
};

// Upload file
export const sendDataToServer = async (formData) => {
  const accessToken = getAccessToken();
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
      formData,
      { headers }
    );
    // console.log("Data successfully uploaded:", response.data);
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
  // console.log("formDataHYYY:", formData);
};

export const EmployeeFileUpload = async (formData) => {
  const accessToken = getAccessToken();
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.employee}`,
      formData,
      { headers }
    );
    return response
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
};

//Hot deals
export const HotDeals = async (id) => {
  try {
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.hotDeals}`,
      {
        headers: {
          SOURCE: "web",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Failed to serviceCard :",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Get ID for website cards
export const serviceCard = async () => {
  try {
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.servicesCard}`,
      {
        headers: {
          SOURCE: "web",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Failed to serviceCard :",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const serviceIdCard = async (id, service_detail_id) => {
  try {
    // console.log("id:", id);
    // console.log("service_detail_id:", service_detail_id);
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.servicesTypeCard}`,
      {
        params: {
          service_id: id,
        },
        headers: {
          SOURCE: "web",
          "SERVICE-DETAIL-ID": service_detail_id,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Failed to serviceCard :",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const addressProvinces = async () => {
  try {
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.addressProvince}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch Provinces:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const sample = async (cardType) => {
  try {
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.cardSample}`,
      {
        headers: {
          SOURCE: "web",
        },
        params: {
          type: cardType,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch sample cards:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
export const previewCard = async (class_id, cardType, user_lists) => {
  const accessToken = getAccessToken();
// console.log('Access Token:', accessToken);
  // console.log('class_id:', class_id);
  // console.log('cardType:', cardType);
  // console.log('user_list:', user_lists);
  try {
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.previewCard}`,
 
      {
        headers: {
          SOURCE: "web",
          "CLASS-ID": class_id,
          "USER-LIST": user_lists,
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          type: cardType, 
        },
      }
    );

    return response.data;
  } catch (error) {
    const errorMsg =
      error.response?.data?.message ||
      error.response?.data?.mesage ||
      error.message ||
      "An error occurred while fetching the preview card.";

    await Swal.fire({
      icon: "error",
      title: "Error",
      text: errorMsg,
    });

    throw error;
  }
};

// export const previewCard = async (class_id, cardType , user_list) => {
//   const accessToken = getAccessToken();
//   try {
//     const response = await axios.get(
//       `${apiConfig.baseUrl}${apiConfig.previewCard}`,
//      { user_list: user_list,},
//       {
//         headers: {
//           SOURCE: "web",
//           "CLASS-ID": class_id,
//           Authorization: `Bearer ${accessToken}`,
//         },
//         params: {
//           type: cardType,
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     const errorMsg = error.response?.data?.message || error.response?.data?.mesage || error.message || 'An error occurred while fetching the preview card.';
//     await Swal.fire({
//             icon: 'error',
//             title: 'Error',
//             text: errorMsg,
//         });
//     throw error;
//   }
// };

export const getAssignedCard = async (cardType) => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.assignedCardSample}`,
      {
        params: {
          type: cardType,
        },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          SOURCE: "web",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// export const postSampleCards = async (formData) => {
//   const accessToken = getAccessToken();
//   for (let [key, value] of formData.entries()) {
//     console.log(`${key}:`, value);
//   }

//   // Make POST request
//   try {
//     const response = await axios.post(
//       `${apiConfig.baseUrl}${apiConfig.assignedCardSample}`,
//       formData,
//       {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           SOURCE: "web",
//         },
//       }
//     );
//   } catch (error) {
//     console.error("Error uploading file:", error.response || error);
//   }
// };
export const postSampleCards = async (data) => {
  const accessToken = getAccessToken();

  // console.log("Payload:", data); // optional: log the plain object

  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.assignedCardSample}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          SOURCE: "web",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
    throw error;
  }
};

export const deleteSampleCards = async (cardId) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios.delete(
      `${apiConfig.baseUrl}${apiConfig.choosenCardSample}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          SOURCE: "web",
          "CARD-ID": cardId, 
        },
      }
    );
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
};
// export const UpdateSampleCards = async (cardId, classInfo) => {
export const UpdateSampleCards = async (payload) => {
  // console.log("Payload upload ko:", payload);
  const accessToken = getAccessToken();
  try {
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.choosenCardSample}`,
      {
        class_info: payload.class_info,
        school: payload.school,
        card: payload.Choosen_card,
        valid_date: payload.valid_date,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          SOURCE: "web",
          "CARD-ID": payload.card, 
        },
      }
    );
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
};

//EMPLOYEE
export const getEmployee = async () => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.employee}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch employee details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const addEmployeeView = async (formData) => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    throw new Error("No access token found. Please log in first.");
  }
  const response = await axios.post(
    `${apiConfig.baseUrl}${apiConfig.employee}`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
  //   } catch (error) {
  //     console.error(
  //       "Registration failed:",
  //       error.response ? error.response.data : error.message
  //     );
  //     throw error;
  //   }
};

export const updateEmployee = async (formData) => {
  // for (let pair of formData.entries()) {
  //   console.log(pair[0], pair[1]);
  // }
  // const idValue = formData.get("id");
  const accessToken = localStorage.getItem("accessToken");
  try {
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.employee}`,
      formData, // Pass the FormData object
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data", // Important for file uploads
          "EMPLOYEE-ID": formData.get("id"), // Pass the employee ID as a header
        },
      }
    );

    return response.data;
  } catch (err) {
    alert("Error updating employee details:", err.response || err);
  }
};
export const totalCountForDashboard = async () => {

  const accessToken = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.countStudent}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    alert("Error updating employee details:", err.response || err);
  }
};


// enroll student 
export const enrollStudent = async (formData) => {
  const accessToken = getAccessToken();
  try {
    // for (let [key, value] of formData.entries()) {
    //   console.log(key, value);
    // }
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.promoteStudent}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("Student added succussfully:", response.data);
   return true;
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
};
export const checkStudentEnrolment = async (formData) => {
  const accessToken = getAccessToken();
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.checkStudentEnrollment}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("Enrolled Student:", response.data);
   return response.data;
  } catch (error) {
    console.error("Error uploading file:", error.response || error);
  }
};

export const enrollStudentLists = async (year, class_id) => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }
    if (!year) {
      throw new Error("Enroll year is missing.");
    }
    if (!class_id) {
      throw new Error("CLASS-ID is missing.");
    }
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.getEnrollStudent}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "CLASS-ID": class_id,
        },
        params: {
          "year":year,
          "is_active":'False'
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const enrollStudentActiveLists = async (class_id) => {
  try {
    const accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found. Please log in first.");
    }

    if (!class_id) {
      throw new Error("CLASS-ID is missing.");
    }
    const response = await axios.get(
      `${apiConfig.baseUrl}${apiConfig.getEnrollStudent}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          "CLASS-ID": class_id,
        },
        params: {
          "year":2083,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Failed to fetch student details:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchStudent = async (id) => {
      const accessToken = getAccessToken();
      try {
        const res = await fetch(`${apiConfig.baseUrl}${apiConfig.qrStudentsProfile}`,
          {
            headers: {
              Accept: "application/json",
              //Authorization: `Bearer ${accessToken}`,
              "UNIQUE-CODE": id,
            },
      }
        );
        const data = await res.json();
        return data;
      } catch (err) {
        console.error("API error:", err);
      } finally {
        console.log("loding off")
      }
    };


export const UpdateBulkRollNumber = async (payload) => {
  const accessToken = getAccessToken();
  console.log(payload)
  try {
    const response = await axios.post(
      `${apiConfig.baseUrl}${apiConfig.updateStudentRollNumber}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating students:", error.response || error);
  }
};



